<template>
	<div id="app">
		<transition mode="out-in">
			<router-view />
		</transition>

		<!-- <CustomizeProduct /> -->
		<Compare />

		<!-- Notification components -->
		<Alerts />
		<UploadAlerts />
	</div>
</template>

<script>
import './assets/less/index.less';
import './libs/clarks/styles/index.less';
import notifications from '@/libs/notifications';
import VTooltip from 'v-tooltip';
import Vue from 'vue';

Vue.use(VTooltip); // Registering v-tooltip globally

export default {
	name: 'app',
	created() {
		Event.$on('auth:logout', (payload) => {});

		Event.$on('loader:show', (status) => {
			this.showLoader = status;
		});
	},
	components: {
		...notifications.components,
		// CustomizeProduct: () => import('@/components/main/product/customize-product'),
		Compare: () => import('@/components/main/compare/compare'),
	},
	data() {
		return {
			showLoader: true,
		};
	},
	async mounted() {
		utils.printAppInfo();
		this.$store.dispatch('initializeSocket');
	},
};
</script>

<style lang="less">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	.app-loader {
		background: rgba(#fff, 0.95);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 7500;
		display: flex;
		justify-content: center;

		.center-text {
			position: absolute;
			top: calc(50% - 200px);
			text-align: center;
			color: var(--primary);

			.loading {
				height: 150px;
				width: auto;
			}
		}
		.txt {
			margin-top: 20px;
			font-size: 16px;
			font-weight: 600;
		}
	}
}
</style>
